<template>
  <div id="tabbar">
    <router-view />
    <van-tabbar route="" active-color="red" v-model="active">
      <van-tabbar-item replace to="/" icon="wap-home-o">首页</van-tabbar-item>
      <van-tabbar-item replace to="/community" icon="friends-o">社区</van-tabbar-item>
      <!-- <van-tabbar-item replace to="/service" icon="apps-o">服务</van-tabbar-item> -->
      <van-tabbar-item replace to="/shop" icon="shop-o">兑换好礼</van-tabbar-item>
      <van-tabbar-item replace to="/mine" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import {
  Tabbar,
  TabbarItem,
} from 'vant';

export default {
  name: 'mTabBar',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  data() {
    return {
      active: 0
    };
  },
  methods: {}
};
</script>

<style lang="less" scoped>
</style>
